<template>
  <div class="row">
    <div class="col-12 my-3">
      <div class="row d-flex justify-content-between align-items-center px-5">
        <el-tag
          v-for="(tag, index) in tags"
          class="col-2 text-cello font-weight-bold shadow-tag"
          :key="index"
          :type="getType(index)"
          >{{ tag }}</el-tag
        >
      </div>
    </div>

    <div class="col-12">
      <business-information-tab
        :initial_business="business"
        v-if="active_tag == 0"
        @save-data="saveData"
      />
      <business-contact-tab
        :initial_business="business"
        v-if="active_tag == 2"
        @save-data="saveData"
      />
      <business-pic-details-tab
        :initial_business="business"
        v-if="active_tag == 1"
        @save-data="saveData"
      />
      <business-additional-documents-tab
        :initial_business="business"
        v-if="active_tag == 3"
        @save-data="saveData"
      />
      <business-registration-complete
        :initial_business="business"
        v-if="active_tag == 4"
        @save-data="saveData"
      />
    </div>
  </div>
</template>
<script>
import BusinessPicDetailsTab from "./tabs/BusinessPicDetailsTab.vue";

export default {
  components: { BusinessPicDetailsTab },
  props: {
    initial_business: {
      type: Object,
    },
  },
  mounted() {},
  data() {
    return {
      tags: [
        "ABN Check & Business Info Details",
        "Contact Information",
        "PIC Details",
        "AML Additional Documents",
        "COMPLETE",
      ],
      business: this.initial_business,
      abn_data: true,
      active_tag: this.initial_business
        ? this.initial_business.onboarding_step
        : 0,
    };
  },
  methods: {
    getType(index) {
      if (this.active_tag > index) return "success";
      else if (index > this.active_tag) return "info";
    },
    saveData(business) {
      if (business) this.business = business;
      //this.active_tag = this.business.onboarding_step;
      this.active_tag += 1;
    },
  },
};
</script>
<style scoped>
.shadow-tag {
  box-shadow: 0 0.2rem 5px rgb(0 0 0 / 15%) !important;
}
</style>
